<template>

  <div @click="animateIndicator"
    class="relative pl-4 pr-6 h-14 flex items-center overflow-hidden transition-all text-nowrap rounded-4xl">
    <div class="z-10 flex items-center">
      <div class="icon mr-3">
        <slot name="icon">
          <div
            class="rounded-full text-sm border text-white border-gray-700 h-8 w-8 flex items-center justify-center"
            :style="{ backgroundColor: avatarColor, borderColor: avatarColor }">
            {{ shortLabel }}
          </div>
        </slot>
      </div>
      <div class="label transition-all" :class="{ 'font-bold': active }">
        {{ label }}
      </div>
      <div class="badge">
      </div>

      <div class="w-full h-full left-0 top-0 z-0 absolute overflow-hidden"
        :class="[
          { 'bg-purple-900/10': active }
        ]"></div>
    </div>

    <div ref="indicator"
      class="w-full h-full left-0 top-0 z-0 absolute overflow-hidden transition-all"
      :class="[
        { 'bg-purple-100/90': active }
      ]"></div>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import { RouteLocationRaw, useRouter } from 'vue-router';
import { colorsUtils } from '../../utils/ColorsUtils';

const props = defineProps<{
  label: string
  to: RouteLocationRaw
  position?: number
}>()

// const route = useRoute();
const router = useRouter();

const active = computed(() => router.resolve(props.to).fullPath == router.currentRoute.value.fullPath);

const indicator = ref<HTMLElement | undefined>(undefined);

const emits = defineEmits<{
  (e: 'finished'): void
}>()

const animateIndicator = () => {
  indicator.value?.classList.add('on-click-animation');

  setTimeout(() => {
    indicator.value?.classList.remove('on-click-animation');
    emits('finished');
    router.push(props.to);
  }, 250);
}

// Get the 
const shortLabel = computed(() => {
  // Get the initials of the label

  // If there is a space in the label; take the first letter of the 2 first words
  if (props.label.includes(' ')) {
    return getInitials(props.label, 2);
  }

  // If there is no space in the label; take the first 2 letters;
  // Capitalize the first letter and make the second letter lowercase
  return getCapitalized(props.label, 2);
})

const getInitials = (text: string, nbInitials: number) => {
  return text.split(' ').map(word => word.charAt(0)).join('').substr(0, nbInitials);
}

const getCapitalized = (text: string, length: number) => {
  return text.charAt(0).toUpperCase() + text.substring(1, length).toLowerCase();
}

const avatarColor = computed(() => {
  if (props.position === undefined) {
    return colorsUtils.getColor(0);
  }

  const color = avatarColors[props.position % avatarColors.length];
  return color;
})

const avatarColors = [
  "#ffbe0b",
  "#fb5607",
  "#ff006e",
  "#8338ec",
  "#3a86ff",
]
</script>